import { render, staticRenderFns } from "./LogBooksDashboard.vue?vue&type=template&id=1d49de03&scoped=true"
import script from "./LogBooksDashboard.vue?vue&type=script&lang=js"
export * from "./LogBooksDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d49de03",
  null
  
)

export default component.exports